import { render, staticRenderFns } from "./QServCommodityComp.vue?vue&type=template&id=65891826&"
import script from "./QServCommodityComp.vue?vue&type=script&lang=js&"
export * from "./QServCommodityComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports